import { render, staticRenderFns } from "./visualizarexame.vue?vue&type=template&id=3b63b7d9"
import script from "./visualizarexame.vue?vue&type=script&lang=js"
export * from "./visualizarexame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports